import get from 'lodash/get';
export const unwrapGraphQlList = (obj, path) => get(obj, path, []).map((edge) => edge.node);
